import { createModuleStore } from '@/stores/utils'
const createInitialFilterState = () => {
  return {
    selectedLogLevels: [],
    selectedUsernames: [],
    startTimestamp: null,
    endTimestamp: null,
    period: 'PAST_3_MONTHS',
  }
}
export const useRemoteErrorLoggerStore = createModuleStore(
  'remoteErrorLogger',
  {
    type: 'Remote Error Logger',
    pageHeading: 'Error Logs',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uploadOptionsCsv: '',
    downloadOptionsCsv: '',
    noAdd: true,
    uri: '/remote-error-logger',
    noStatus: true,
    serviceUri: '/logs',
    listingModuleName: 'Reports',
    listingActivityName: 'View Remote Error Logs',
    allFields: [
      {
        key: 'username',
        title: 'USERNAME',
        visible: true,
        sortable: true,
        disabled: true,
      },
      {
        key: 'logLevel',
        title: 'SEVERITY LEVEL',
        visible: true,
        sortable: false,
        disabled: true,
      },
      {
        key: 'message',
        title: 'MESSAGE',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'cause',
        title: 'CAUSE',
        visible: true,
        type: 'errorCause',
        sortable: true,
        disabled: false,
      },
      {
        key: 'culpritClass',
        title: 'CULPRIT CLASS',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'offendingMethod',
        title: 'OFFENDING METHOD',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: false,
        sortable: true,
        disabled: false,
      },
    ],
    apiColumnsMapping: {},
  },
  {
    supportedPageFilters: {
      periodApplicable: 'true',
      selectedUsernames: {
        type: 'usernames',
      },
    },
    filters: createInitialFilterState(),
  },
  {
    resetPageFilters() {
      const store = useRemoteErrorLoggerStore()
      store.filters = createInitialFilterState()
      store.supportedPageFilters.periodApplicable = 'true'
      store.resetBaseFilters()
    },
  },
  {}
)
